import {Component, Input} from '@angular/core';
import {SubscribeComponent} from "../subscribe/subscribe.component";
import {RouterLink} from "@angular/router";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgIf} from "@angular/common";
import {ContactFormData} from "../../../models/model";
import {ExternService} from "../../../services/extern.service";
import {take} from "rxjs";



@Component({
    selector: 'app-contact',
    standalone: true,
    templateUrl: './contact.component.html',
    imports: [
        SubscribeComponent,
        RouterLink,
        ReactiveFormsModule,
        NgIf
    ],
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent{
    @Input() isOnHome: boolean = false;

    contactForm: FormGroup;

    constructor(private fb: FormBuilder) {
        this.contactForm = this.fb.group({
            prenom: ['', Validators.required],
            nom: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            objet: [''],
            message: ['', Validators.required]
        });
    }


    redirectToWhatsApp() {
        const data = this.contactForm.value;

        const message = `
Bonjour Monsieur le Président,

Je me permets de vous contacter au nom d’ASESA.

Nom : ${data.prenom} ${data.nom}
Email : ${data.email}
Objet : ${data.objet || '—'}

Message :
${data.message}

Cordialement.
    `.trim();

        const phoneNumber = '22891181292';
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
    }

}
